<script lang="ts">
  import { utils } from '../../utils'
  import Input from './Input.svelte'

  export let active = false
  export let id: string | undefined = undefined
  export let disabled = false
  export let name: string | undefined = undefined
  const toggleId = id || `toggle-${utils.getRandomString(8)}`

  function handleClick() {
    active = !active
  }
</script>

<div class="container" class:disabled>
  <div class="selection-container">
    <div class="track" class:active class:disabled></div>
    <div class="button-container" class:active class:disabled>
      <button
        type="button"
        role="switch"
        aria-checked={active}
        on:click={handleClick}
        on:click
        id={toggleId}
        {disabled}
      >
        <span aria-hidden="true" class="hidden">Off</span>
        <span aria-hidden="true" class="hidden">On</span>
      </button>
      <div class="thumb"></div>
    </div>
    <Input
      type="checkbox"
      {name}
      hidden
      checked={active}
      value={active ? 'true' : ''}
    />
  </div>

  {#if $$slots.default}
    <label for={toggleId} class:disabled><slot /></label>
  {/if}
</div>

<style lang="scss">
  .container {
    display: flex;
    align-items: center;
    gap: 1em;

    &.disabled {
      opacity: 0.38;
    }

    .selection-container {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;

      .track {
        border-radius: 8px;
        height: 14px;
        opacity: 0.6;
        width: 36px;
        cursor: pointer;
        background-color: var(--color-on-surface);

        &.active {
          background-color: var(--toggle-color, var(--color-primary));
        }

        &.disabled {
          cursor: default;
        }
      }

      .button-container {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        transition: 0.15s transform cubic-bezier(0.4, 0, 0.2, 1);
        transform: translate(-10px);

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 100%;
          background-color: currentColor;
          opacity: 0;
          pointer-events: none;
        }

        &:not(.disabled):hover::before {
          opacity: 0.04;
        }

        &.active {
          transform: translate(10px);

          .thumb {
            background-color: var(--toggle-color, var(--color-primary));
          }
        }

        button {
          position: absolute;
          appearance: none;
          background: none;
          border: none;
          opacity: 0;
          width: 100%;
          height: 100%;
          padding: 0;
          cursor: pointer;

          .hidden {
            visibility: hidden;
          }

          &[disabled] {
            cursor: default;
          }
        }

        .thumb {
          display: flex;
          pointer-events: none;
          background-color: #fff;
          width: 20px;
          height: 20px;
          border-radius: 100%;
          box-shadow:
            0 2px 4px -1px rgba(0, 0, 0, var(--box-shadow-opacity-1, 0.2)),
            0 4px 5px 0 rgba(0, 0, 0, var(--box-shadow-opacity-2, 0.14)),
            0 1px 10px 0 rgba(0, 0, 0, var(--box-shadow-opacity-3, 0.12));
        }
      }
    }

    label:not(.disabled) {
      cursor: pointer;
    }
  }
</style>
